import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const BannerSkeleton = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const xs = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <SkeletonTheme
      baseColor="#D8DBE0"
      highlightColor="#EDF1F6"
      borderRadius={"0"}
    >
      {md && <Skeleton width={"100%"} height={370} />}
      {sm && <Skeleton width={"100%"} height={290} />}
      {xs && <Skeleton width={"100%"} height={250} />}
    </SkeletonTheme>
  );
};

export default BannerSkeleton;
